export type Installation = {
  type: 'residential' | 'hospitality';
  src: string;
  id: any;
  name?: string;
  colors?: InstallColor[];
};

export type InstallColor = {
  src: string;
  to: string;
};

export const installations: Installation[] = [
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/breakers-palm-beach.jpg',
    id: 1,
    name: 'Breakers Palm Beach',
    colors: [
      {
        src: '/media/installations/hospitality/breakers-palm-beach_ID76620.jpg',
        to: '/product/76619/76620',
      },
    ],
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/editions-west-hollywood-1.jpg',
    id: 2,
    name: 'Editions West Hollywood',
    colors: [
      {
        src: '/media/installations/hospitality/editions-west-hollywood-1_ID92337.jpg',
        to: '/product/92336/92337',
      },
    ],
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/editions-west-hollywood-2.jpg',
    id: 3,
    name: 'Editions West Hollywood',
    colors: [
      {
        src: '/media/installations/hospitality/editions-west-hollywood-2_ID92343.jpg',
        to: '/product/92342/92343'
      },
    ],
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/four-seasons-san-francisco.jpg',
    id: 4,
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/kabuki-hotel.jpg',
    id: 5,
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/grand-hyatt-nashville.jpg',
    id: 6,
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/one-hotel-toronto.jpg',
    id: 7,
  },
  {
    type: 'hospitality',
    src: '/media/installations/hospitality/one-hotel-toronto-room.jpg',
    id: 8,
  },
  {
    type: 'residential',
    src: '/media/installations/residential/enlightened-tiger-collection.jpg',
    id: 9,
    colors: [
      {
        src: '/media/installations/residential/enlightened-tiger-collection_ID108272.jpg',
        to: '/product/108266/108272',
      },
      {
        src: '/media/installations/residential/enlightened-tiger-collection_2.jpg',
        to: '/product/108266/108267',
      },
      {
        src: '/media/installations/residential/enlightened-tiger-collection_3.jpg',
        to: '/product/108266/108268',
      },
      {
        src: '/media/installations/residential/enlightened-tiger-collection_4.jpg',
        to: '/product/108266/108269',
      },
      {
        src: '/media/installations/residential/enlightened-tiger-collection_5.jpg',
        to: '/product/108266/108270',
      },
    ],
  },
  {
    type: 'residential',
    src: '/media/installations/residential/fxn-starry-night.jpg',
    id: 10,
  },
  {
    type: 'residential',
    src: '/media/installations/residential/pf-yellowwood.jpg',
    id: 11,
  },
  {
    type: 'residential',
    src: '/media/installations/residential/lania-lane-master.jpg',
    id: 12,
  },
  {
    type: 'residential',
    src: '/media/installations/residential/lania-lane-living.jpg',
    id: 13,
  },
  {
    type: 'residential',
    src: '/media/installations/residential/greig-entry-rug-living-room-rug.jpg',
    id: 14,
  },
];
